import raw from "./raw/icon-accepted-24x24.svg";
import { IconBuilder } from "./builder/IconBuilder";

export const Accepted = IconBuilder({
    svg: raw,
    defaultColor: theme => theme.success1
});
